export class CityListService {
  static CHANNEL_HAVEN = 'HAVEN';
  static CHANNEL_MMDIRECT = 'MMDIRECT';
  static CHANNEL_COVERPATH = 'COVERPATH';

  private city: string = '';
  private cityList: string[] = [];
  private stateCode: string = '';
  private multiCityFlag: boolean = false;
  private channel: string;

  constructor(channel: string, location: { [key: string]: any }) {
    this.channel = channel;
    if (Array.isArray(location.city)) {
      this.cityList = location.city;
      this.multiCityFlag = true;
    } else {
      this.city = location.city;
    }
    this.stateCode = location.stateCode;
  }

  getCity(): string {
    if (this.channel === CityListService.CHANNEL_HAVEN) {
      return this.multiCityFlag ? '' : this.city;
    } else {
      return this.multiCityFlag ? this.cityList[0] : this.city;
    }
  }

  getCityList(): string[] {
    return this.cityList;
  }

  getStateCode(): string {
    return this.stateCode;
  }

  getCityStateCode(): { city: string; state: string } {
    return { city: this.city, state: this.stateCode };
  }
}
